import { styled } from '../../theme';
import { Column } from '../Column';
import { Waiter } from '../Waiter';

export const Wrapper = styled(Column)`
	> * {
		margin-bottom: ${({ theme }) => theme.space.lg}px;

		&:last-child {
			margin-bottom: 0;
		}
	}
`;

export const $Waiter = styled(Waiter)`
	width: 100%;
`;
